<template>
  <div :class="{ mobile: isMobile }">
    <div class="title-wrapper">
      <span class="title" :class="{ active: index === 0 }" @click="index = 0"
        >History</span
      >
      <span class="title" :class="{ active: index === 1 }" @click="index = 1"
        >Filters</span
      >
      <span class="title" :class="{ active: index === 2 }" @click="index = 2"
        >Triggers</span
      >
      <span class="title" :class="{ active: index === 3 }" @click="index = 3"
        >Notifications</span
      >
    </div>
    <div v-if="index === 0" class="content-wrapper">
      <AlertRSHistoryTable
        :historyDataList="alertDataObj.historyData"
      ></AlertRSHistoryTable>
    </div>
    <div v-if="index === 1" class="content-wrapper">
      <AlertRSFiltersTable
        :alertFiltersType="alertFiltersType"
        :filterDataList="filterDataList"
        :alertId="alertDataObj.id"
      ></AlertRSFiltersTable>
    </div>
    <div v-if="index === 2" class="content-wrapper">
      <AlertRSTriggersTable
        :alertTriggersType="alertTriggersType"
        :triggerDataList="triggerDataList"
      ></AlertRSTriggersTable>
    </div>
    <div v-if="index === 3" class="content-wrapper">
      <AlertRSActionsTable
        :actionDataList="actionDataList"
      ></AlertRSActionsTable>
    </div>
  </div>
</template>

<script>
import AlertRSHistoryTable from './AlertRSHistoryTable.vue';
import AlertRSFiltersTable from './AlertRSFiltersTable.vue';
import AlertRSTriggersTable from './AlertRSTriggersTable.vue';
import AlertRSActionsTable from './AlertRSActionsTable.vue';
import { mapGetters } from 'vuex';
import {
  FILTER_TYPE,
  TRIGGER_TYPE,
  ROUTING_STATUS_ALERTS_REQUEST
} from '../../../../constants/alertsRoutingStatusConstant';

export default {
  name: 'AlertRSDetailContainer',
  components: {
    AlertRSHistoryTable,
    AlertRSFiltersTable,
    AlertRSTriggersTable,
    AlertRSActionsTable
  },
  props: {
    alertDataObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      index: 0,
      trigger: {}
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('alertsRoutingStatusStore', [
      'memberContactsOfSelectedAccount'
    ]),

    alertFiltersType() {
      if (
        this.alertDataObj.filterTrigger &&
        this.alertDataObj.filterTrigger.prefix
      )
        return FILTER_TYPE.PREFIX;

      if (
        this.alertDataObj.filterTrigger &&
        this.alertDataObj.filterTrigger.origin
      )
        return FILTER_TYPE.AS;
    },

    filterDataList() {
      if (
        this.alertDataObj.filterTrigger &&
        this.alertDataObj.filterTrigger.prefix
      ) {
        let matchType = '';

        if (
          this.alertDataObj.filterTrigger.prefix.filter &&
          this.alertDataObj.filterTrigger.prefix.filter.prefixes !==
            ROUTING_STATUS_ALERTS_REQUEST.prefixFilter.anyPrefixInMyOrigins
        ) {
          switch (this.alertDataObj.filterTrigger.prefix.filter.matchType) {
            case ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific.exact:
              matchType = ' (exact only)';
              break;
            case ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific.moreSpecific:
              matchType = ' (more specific only)';
              break;
            case ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific
              .exactAndMoreSpecific:
              matchType = ' (exact or more specific)';
              break;
            default:
              break;
          }
        }

        return Object.keys(this.alertDataObj.prefixStatuses || {}).map(
          item => ({
            prefixStatuses: item,
            filterType: 'Prefix' + matchType
          })
        );
      }

      if (
        this.alertDataObj.filterTrigger &&
        this.alertDataObj.filterTrigger.origin
      )
        return Object.keys(this.alertDataObj.originStatuses || {}).map(
          item => ({
            originStatuses: `AS${item}`,
            filterType: 'Origin AS'
          })
        );
    },

    alertTriggersType() {
      if (this.trigger.roa) return TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT;
      if (this.trigger.bgp) return TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS;
    },

    triggerDataList() {
      if (this.trigger.roa) {
        let incident = '';
        const roa = this.trigger.roa;

        if (roa.mismatch) {
          if (roa.notPublished) {
            incident =
              'Not published or mismatch against ROAs or Route objects.';
          } else {
            incident = 'Mismatch against ROAs or Route objects.';
          }
        } else {
          if (this.trigger.roa.notPublished) {
            incident = 'ROA or Route object not published.';
          } else {
            incident = 'None';
          }
        }
        return [{ triggerType: 'RPKI/IRR alignment', incident }];
      }

      if (this.trigger.bgp) {
        let bgpRouting = '';
        const bgp = this.trigger.bgp;

        switch (bgp.announcementStatus) {
          case ROUTING_STATUS_ALERTS_REQUEST.bgpAnnouncementStatus.routeExists:
            bgpRouting = 'Exists';
            break;
          case ROUTING_STATUS_ALERTS_REQUEST.bgpAnnouncementStatus
            .routeDoesntExist:
            bgpRouting = "Doesn't Exist";
            break;
          default:
            break;
        }

        if (
          bgp.originAs ===
          ROUTING_STATUS_ALERTS_REQUEST.bgpOriginAs.anyOriginDelegated
        ) {
          return [
            {
              triggerType: 'BGP status',
              bgpRouting,
              originAS: 'Any origin AS delegated to your account'
            }
          ];
        } else if (
          bgp.originAs ===
          ROUTING_STATUS_ALERTS_REQUEST.bgpOriginAs.anyOriginNotDelegated
        ) {
          return [
            {
              triggerType: 'BGP status',
              bgpRouting,
              originAS: 'Any delegated origin AS not delegated to your account'
            }
          ];
        } else if (
          bgp.originAs &&
          bgp.originAs.individualOrigins &&
          bgp.originAs.individualOrigins.length
        ) {
          return bgp.originAs.individualOrigins.map(item => ({
            triggerType: 'BGP status',
            bgpRouting,
            originAS: `AS${item}`
          }));
        } else {
          return [
            {
              triggerType: 'BGP status',
              bgpRouting,
              originAS: 'Unknown'
            }
          ];
        }
      }
    },

    actionDataList() {
      if (this.alertDataObj.action && this.alertDataObj.action.length) {
        const action = this.alertDataObj.action;

        const actionList = action.map(item => {
          let channel = '';

          switch (item.channel) {
            case ROUTING_STATUS_ALERTS_REQUEST.channel.email:
              channel = 'Email';
              break;
            case ROUTING_STATUS_ALERTS_REQUEST.channel.sms:
              channel = 'SMS';
              break;
            case ROUTING_STATUS_ALERTS_REQUEST.channel.slack:
              channel = 'Slack';
              break;
            default:
              break;
          }

          if (item.recipient && item.recipient.nonApnicUser) {
            return {
              channel,
              recipient: item.recipient.nonApnicUser
            };
          } else if (item.recipient && item.recipient.apnicUser) {
            const apnicUser = item.recipient.apnicUser;
            if (apnicUser === this.oidcUser.userid) {
              return {
                channel,
                recipient: `${this.oidcUser.nickname ||
                  this.oidcUser.email} (myself)`
              };
            } else {
              const member = this.memberContactsOfSelectedAccount.find(
                member => apnicUser === member.uid
              );
              return {
                channel,
                recipient: member && member.name
              };
            }
          }
        });

        // Filter list by checking whether the value of recipient is falsy.
        const list = actionList.filter(item => !!item.recipient);

        return list;
      }
    }
  },
  mounted() {
    if (!this.alertDataObj.filterTrigger) return;

    if (this.alertDataObj.filterTrigger.prefix) {
      this.trigger = this.alertDataObj.filterTrigger.prefix.trigger;
    } else if (this.alertDataObj.filterTrigger.origin) {
      this.trigger = this.alertDataObj.filterTrigger.origin.trigger;
    }
  }
};
</script>

<style lang="scss" scoped>
.title-wrapper {
  margin-bottom: 0.5rem;
  border-bottom: 1px solid $border-grey;

  .title {
    display: inline-block;
    margin: 0 1rem;
    padding: 0.5rem;
    padding-top: 0;
    cursor: pointer;

    &.active {
      border-bottom: 2px solid $text-light-blue;
    }
  }

  .title:nth-child(1) {
    margin-left: 0;
  }
}

.content-wrapper {
  margin: 0 0.5rem;
}

.mobile {
  .title-wrapper {
    display: flex;
    justify-content: space-between;

    .title {
      padding: 0.25rem;
      margin: 0 0.25rem;
    }

    .title:nth-child(1) {
      margin-left: 0;
    }
  }
}
</style>
